// SignaturePadComponent.js
import { Alert, Button, Col, Flex, Row, theme, notification, Spin } from 'antd';
import { EditOutlined, LeftOutlined, DeleteOutlined, VideoCameraOutlined, InboxOutlined, InfoCircleOutlined, RightOutlined } from '@ant-design/icons';
import React, { useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SignaturePad from 'signature_pad';
import SignatureSettingsAPI from '../../../restAPI/SignatureSettingsAPI';
import useCurrentCompany from '../../../hooks/useCurrentCompany';


const DrawSignature = ({goBack}) => {
    const { companyId, token, userCompany } = useSelector(state => state.auth);
    const canvasRef = useRef(null);
    const signaturePadRef = useRef(null);    
    const currentCompanyInfo = useCurrentCompany();
    const [isSaving, setIsSaving] = useState(false);

    const [api, contextHolder] = notification.useNotification();
    const openNotificationWithIcon = (type, message, description, placement) => {
      api[type]({
          message: message,
          description: description,
          placement
      });
    };

    const { token:
        {
            colorBgContainer,
            borderRadiusLG,
            colorBorder,
            colorPrimary
        },
    } = theme.useToken();


    useEffect(() => {
        const canvas = canvasRef.current;
        signaturePadRef.current = new SignaturePad(canvas, {
            penColor: colorPrimary, // Set the initial pen color
            
        });
       

        // Resizing the canvas to fit the container
        const resizeCanvas = () => {
            const ratio = Math.max(window.devicePixelRatio || 1, 1);
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext('2d').scale(ratio, ratio);
            signaturePadRef.current.clear(); // clear the previous content
        };

        window.addEventListener('resize', resizeCanvas);
        resizeCanvas(); // Initialize on mount

        return () => {
            window.removeEventListener('resize', resizeCanvas);
        };
    }, []);

   
    const clearSignature = () => {
        signaturePadRef.current.clear();
    };

    const saveSignature = async () => {
        if (!signaturePadRef.current.isEmpty()) {
            setIsSaving(true);
            const dataURL = signaturePadRef.current.toDataURL();
            //console.log(dataURL); // You can use this dataURL to send or save the signature

            const fetchResponse = await fetch(dataURL);
            const blob = await fetchResponse.blob();
            const formData = new FormData();
            formData.append('signature', blob, 'signature.png');

            await SignatureSettingsAPI.saveeSignature(formData, companyId, token)
                .then((response) => {
                    openNotificationWithIcon('success', "Successful", `${response.message}`, 'bottomLeft');
                    // Delay navigation to ensure notification is visible
                    setTimeout(() => {
                        setIsSaving(false);
                        goBack();
                    }, 1500); // 1.5 second delay
                })
                .catch((err) => {
                    setIsSaving(false); // Stop loading on error
                    if (err.response) {
                        openNotificationWithIcon('error', 'eSignature creation failed', `${err.response.data.message}`, 'bottomLeft');
                    } else {
                        openNotificationWithIcon('error', 'eSignature creation failed', `${err.message}`, 'bottomLeft');
                    }
                });
        }
    };

    return (
        <>
            <div style={{
                margin: '16px',
                padding: '8px 12px',
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Flex justify='space-between' align='center'>
                    <Flex justify='flex-start' align='center' gap={16}>
                        {/* enable this only on mobile size  */}
                        <Button type="text" icon={<LeftOutlined />} onClick={goBack} />
                        <span>Draw New Signature</span>
                    </Flex>
                    {/* <Button type="primary"> Edit </Button> */}
                </Flex>
            </div>

            <div style={{
                margin: '16px',
                padding: '24px 12px',
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Alert
                    type="warning"
                    message="Please Sign Inside the Box"
                    showIcon
                    closable />
                <canvas
                    ref={canvasRef}
                    style={{
                        width: '100%',
                        height: '100%',
                        border: `1px solid ${colorBorder}`,
                        borderRadius: borderRadiusLG,
                        marginTop: 16,
                        marginBottom: 16
                    }}
                ></canvas>
                <Flex align='center' justify='flex-end' gap={16}>
                    <Button type="default" onClick={clearSignature} disabled={isSaving}>
                        Clear
                    </Button>
                    <Button type="primary" onClick={saveSignature} loading={isSaving} disabled={isSaving}>
                        {isSaving ? 'Saving...' : 'Save'}
                    </Button>
                </Flex>
            </div>
            {contextHolder}
        </>
    );
};

export default DrawSignature;
